import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

export default function ThinkyIOTAutomationEngine({ onBack }) {
  // Dummy rule chains
  const initialRules = [
    { id: 1, name: 'High Temp Alert', device: 'Device A', condition: 'Temperature > 70', action: 'Send Email', status: 'Active' },
    { id: 2, name: 'Low Battery Notification', device: 'Device B', condition: 'Battery < 20%', action: 'Push Notification', status: 'Inactive' },
    { id: 3, name: 'Offline Device Alarm', device: 'Device C', condition: 'Status = Offline', action: 'Trigger SMS', status: 'Active' },
  ];

  const [rules, setRules] = useState(initialRules);

  // Dummy telemetry data for chart
  const generateTelemetry = () => Array.from({ length: 10 }, () => Math.floor(Math.random() * 100));

  const toggleRuleStatus = (id) => {
    setRules(rules.map(r => r.id === id ? { ...r, status: r.status === 'Active' ? 'Inactive' : 'Active' } : r));
  };

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Rules & Automation Engine</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rules.map(rule => (
          <div key={rule.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{rule.name}</h3>
            <p>Device: <span className="font-medium">{rule.device}</span></p>
            <p>Condition: <span className="font-medium text-blue-400">{rule.condition}</span></p>
            <p>Action: <span className="font-medium text-green-400">{rule.action}</span></p>
            <p>Status: <span className={`font-semibold ${rule.status === 'Active' ? 'text-green-400' : 'text-gray-400'}`}>{rule.status}</span></p>

            <button
              onClick={() => toggleRuleStatus(rule.id)}
              className="mt-3 px-3 py-1 bg-blue-600 rounded hover:bg-blue-500 text-sm"
            >
              Toggle Status
            </button>

            <div className="mt-4 h-20">
              <Line
                data={{
                  labels: Array.from({ length: 10 }, (_, i) => i + 1),
                  datasets: [{
                    label: 'Telemetry Preview',
                    data: generateTelemetry(),
                    borderColor: '#f97316',
                    backgroundColor: 'rgba(249, 115, 22, 0.2)',
                    tension: 0.3,
                    pointRadius: 0,
                  }]
                }}
                options={{
                  responsive: true,
                  plugins: { legend: { display: false } },
                  scales: { x: { display: false }, y: { display: false } }
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}